module.exports = __webpack_public_path__ + "img/Habenleumi45.5543af0e.png";